
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBuoySuper as ObiSimplifiedBuoySuperElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-buoy-super.js';
 
 
 

 
 export const ObiSimplifiedBuoySuper = createComponent({
   react: React,
   tagName: 'obi-simplified-buoy-super',
   elementClass: ObiSimplifiedBuoySuperElement,
   events: {
     
   }
  });
 
 